import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";
import { ApplyInputTypeInfo, SubscribeInfoData } from "./agent-user-subinfo-get";

// 原始接口
interface AgentOperationLogResponse {
  list: Array<List>;
  page: number;
  page_size: number;
  total: number;
  total_pages: number;
}
export interface List {
  id: number;
  user_id: number;
  username: string;
  operation_module: number;
  operation_type: number;
  operation_object_id: string;
  operation_time: number;
};

// 请求接口
export interface AgentOperationLogsListRequest {
  page?: number;
  pageSize?: number;
  filterType?: string;
  filterKeyword?: string;
  moduleType?: string;
  startDate?: string;
  endDate?: string;
  agentId: string;
}

export class AgentOperationLogData {
  @Required("Id cannot be empty")
  @IsString("Id must be a string")
  id: string;

  @Required("operationId cannot be empty")
  @IsNumber("operationId must be a number")
  operationId: number;

  @Required("User id cannot be empty")
  @IsNumber("User id must be a number")
  userId: number;

  @Required("Username cannot be empty")
  @IsString("Username must be a string")
  username: string;

  @Required("Operation module cannot be empty")
  @IsNumber("Operation module must be a number")
  operationModule: number;

  @Required("Operation type cannot be empty")
  @IsNumber("Operation type must be a number")
  operationType: number;

  @Required("Operation object id cannot be empty")
  @IsString("Operation object id must be a string")
  operationObjectId: string;

  @Required("Operation time cannot be empty")
  @IsNumber("Operation time must be a number")
  operationTime: number;

  // @Required("Operation object name cannot be empty")
  @IsString("Operation object name must be a string")
  operationObjectName: string;
}

export class AgentOperationLogsListData {
  @IsArray("Operation logs must be an array")
  list: AgentOperationLogData[];

  @Required("Page cannot be empty")
  @IsNumber("Page must be a number")
  page: number;

  @Required("Page size cannot be empty")
  @IsNumber("Page size must be a number")
  pageSize: number;

  @Required("Total cannot be empty")
  @IsNumber("Total must be a number")
  total: number;

  @Required("Total pages cannot be empty")
  @IsNumber("Total pages must be a number")
  totalPages: number;
}

const transformAndValidateAgentOperationLog = (
  response: AgentOperationLogResponse
): AgentOperationLogsListData => {
  const transformedData = transformKeys(response);
  try {
    const data = DataValidator.validateOrThrow(transformedData, AgentOperationLogsListData);
    if (!data.list) {
      data.list = []
    }
    return data;
  } catch (error) {
    console.error("Agent operation log data validation failed:", error.message);
    throw error;
  }
};

/** 获取 Agent 操作日志列表 */
export const agentOperationLogsList = async ({
  page,
  pageSize,
  filterType,
  filterKeyword,
  moduleType,
  endDate,
  startDate,
  agentId,
}: AgentOperationLogsListRequest): Promise<AgentOperationLogsListData> => {
  const response = await api.post<AgentOperationLogResponse>('/agent/operation-logs/list', {
    page,
    page_size: pageSize,
    filter_type: filterType,
    filter_keyword: filterKeyword,
    module_type: moduleType,
    end_time: endDate,
    start_time: startDate,
    agent_id: agentId,
  });
  const data = transformAndValidateAgentOperationLog(response.data);
  return data;
};
